module.exports = __webpack_public_path__ + "img/withdrawn.717ab0ef.png";